const hosts = new Set([
  'fashionunited.at',
  'fashionunited.be',
  'fashionunited.be/fr',
  'fashionunited.ca',
  'fashionunited.ca/fr',
  'fashionunited.ch',
  'fashionunited.cl',
  'fashionunited.co',
  'fashionunited.com',
  'fashionunited.com.ar',
  'fashionunited.com.br',
  'fashionunited.com.pe',
  'fashionunited.com.tr',
  'fashionunited.cz',
  'fashionunited.de',
  'fashionunited.dk',
  'fashionunited.es',
  'fashionunited.fi',
  'fashionunited.fr',
  'fashionunited.hk',
  'fashionunited.hu',
  'fashionunited.ie',
  'fashionunited.in',
  'fashionunited.it',
  'fashionunited.jp',
  'fashionunited.lu',
  'fashionunited.mx',
  'fashionunited.nl',
  'fashionunited.no',
  'fashionunited.nz',
  'fashionunited.pl',
  'fashionunited.pt',
  'fashionunited.se',
  'fashionunited.uk',
  'ae.fashionunited.com',
  'au.fashionunited.com',
  'az.fashionunited.com',
  'bd.fashionunited.com',
  'bg.fashionunited.com',
  'bo.fashionunited.com',
  'ci.fashionunited.com',
  'cn.fashionunited.com',
  'cr.fashionunited.com',
  'cy.fashionunited.com',
  'do.fashionunited.com',
  'dz.fashionunited.com',
  'ec.fashionunited.com',
  'ee.fashionunited.com',
  'eg.fashionunited.com',
  'ge.fashionunited.com',
  'gh.fashionunited.com',
  'gr.fashionunited.com',
  'gt.fashionunited.com',
  'hn.fashionunited.com',
  'hr.fashionunited.com',
  'id.fashionunited.com',
  'il.fashionunited.com',
  'jo.fashionunited.com',
  'ke.fashionunited.com',
  'kh.fashionunited.com',
  'kr.fashionunited.com',
  'kz.fashionunited.com',
  'lb.fashionunited.com',
  'lk.fashionunited.com',
  'lt.fashionunited.com',
  'lv.fashionunited.com',
  'ma.fashionunited.com',
  'mg.fashionunited.com',
  'mt.fashionunited.com',
  'my.fashionunited.com',
  'ng.fashionunited.com',
  'np.fashionunited.com',
  'pa.fashionunited.com',
  'ph.fashionunited.com',
  'pk.fashionunited.com',
  'pr.fashionunited.com',
  'py.fashionunited.com',
  'ro.fashionunited.com',
  'rs.fashionunited.com',
  'ru.fashionunited.com',
  'sa.fashionunited.com',
  'sg.fashionunited.com',
  'si.fashionunited.com',
  'sk.fashionunited.com',
  'sn.fashionunited.com',
  'sv.fashionunited.com',
  'th.fashionunited.com',
  'tn.fashionunited.com',
  'tw.fashionunited.com',
  'ua.fashionunited.com',
  'uy.fashionunited.com',
  'uz.fashionunited.com',
  've.fashionunited.com',
  'vn.fashionunited.com',
  'za.fashionunited.com',
]);

const isJobsComplete = (host) => hosts.has(host);

export default isJobsComplete;
